import { render, staticRenderFns } from "./ui-breadcrumbs.vue?vue&type=template&id=09345a59&scoped=true&"
import script from "./ui-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ui-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ui-breadcrumbs.vue?vue&type=style&index=0&id=09345a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09345a59",
  null
  
)

export default component.exports